import Grid from "../Grid/Grid";

function Spinner() {
  return (
    <Grid>
      <div className="spinner-container">
        <div className="spinner" />
      </div>
    </Grid>
  );
}

export default Spinner;
